import styled from "styled-components";
import { Flex, Type } from "@ebscois/react-component-library";

export const StyledWrapper = styled(Flex)`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
    padding-bottom: ${({ theme }) => theme.space.sm};
  }
`;

export const StyledPubTypeWrapper = styled(Type)`
  padding-bottom: ${({ theme }) => theme.space.sm};
  font-size: ${({ theme }) => theme.font.size.sm};

  @media print {
    display: block;
  }
`;
